import { Role } from '../types/auth';

// V4 D10 (2026-04-22): entry `dashboard` eliminado del sidebar — Dashboard
// desactivado hasta rediseño. La ruta `/dashboard` redirige a `/work-orders`.
export const getOptions = (t: (key: string) => string) => [
  {
    label: t('navigation:menu.communications'),
    value: 'communication',
    permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.RoomTeam],
  },
  {
    label: t('navigation:menu.workOrders'),
    value: 'work-orders',
    permissions: [
      Role.Coex,
      Role.Capataz,
      Role.SuperAdmin,
      Role.Tablet,
      Role.RoomTeam,
    ],
  },
  {
    label: t('navigation:menu.surveillance'),
    value: 'surveillance-route',
    // Capataz (fix 2026-07-20): clon de Coex — el backend SR ya le daba
    // acceso completo (@Roles + matriz D5 con tripwire de paridad), pero sin
    // esta entrada no podía llegar a la sección desde el menú.
    permissions: [
      Role.SuperAdmin,
      Role.Coex,
      Role.Capataz,
      Role.RoomTeam,
      Role.Tablet,
    ],
  },
  {
    label: t('navigation:menu.reporting'),
    value: 'reporting',
    // RoomTeam entra para conservar su acceso a Comunicaciones Históricas
    // (antes en la sección Comunicaciones). El submenú filtra por rol, así que
    // RoomTeam solo verá esa entrada dentro de Informes.
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz, Role.RoomTeam],
  },
  {
    label: t('navigation:menu.management'),
    value: 'management',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    label: t('navigation:menu.admin'),
    value: 'admin',
    permissions: [Role.SuperAdmin],
  },
];

// Para compatibilidad con imports existentes - usar valores por defecto
// V4 D10 (2026-04-22): entry `dashboard` eliminado — ver nota arriba.
export const options = [
  {
    label: 'Comunicacions',
    value: 'communication',
    permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.RoomTeam],
  },
  {
    label: 'Ordres de Treball',
    value: 'work-orders',
    permissions: [
      Role.Coex,
      Role.Capataz,
      Role.SuperAdmin,
      Role.Tablet,
      Role.RoomTeam,
    ],
  },
  {
    label: 'Recorregut de Vigilància',
    value: 'surveillance-route',
    permissions: [
      Role.SuperAdmin,
      Role.Coex,
      Role.Capataz,
      Role.RoomTeam,
      Role.Tablet,
    ],
  },
  {
    label: 'Informes',
    value: 'reporting',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz, Role.RoomTeam],
  },
  {
    label: 'Gestió',
    value: 'management',
    permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz],
  },
  {
    label: 'Administració',
    value: 'admin',
    permissions: [Role.SuperAdmin],
  },
];
